module.exports = __webpack_public_path__ + "img/swiper2.95d595b6.jpg";